import {
  Button,
  Card,
  Form as FormAnt,
  Grid,
  Input,
  InputNumber,
  Select,
  Space,
  Spin,
  Typography,
} from 'antd';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import {
  useCompanyData,
  useGetPrice,
  useGetProducts,
  useStripListType,
  useUsersMe,
} from '../../../../../../../Hooks/TT_ELD/Companies';
import { sendEvent } from '../../../../../../../Utils/analytics';
import { companies } from '../../../../../../../API/TT_ELD/Users/company';
import { getUserFromLocalStorage } from '../../../../../../../Utils/sidebar';

const { Text } = Typography;

const { Option } = Select;
const { useBreakpoint } = Grid;
type params = {
  readonly id: any;
};
type MyObjectType = {
  [key: string | number]: any;
};

const downloadCSV = (csvData: string, filename = 'stripe-logs.csv') => {
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const Stripe = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const { id } = useParams<params>();
  const { data, refetch }: MyObjectType = useCompanyData(id);
  const { data: stripeMap }: MyObjectType = useStripListType();
  const [productId, setProductId] = useState<string | undefined>(undefined);
  const getProducts = useGetProducts(id);
  const getPrices = useGetPrice(id, productId);
  const userMe: MyObjectType = useUsersMe(id);
  const role = getUserFromLocalStorage()?.role;
  const canEditPrice = role === 'sales' || role === 'manager';
  const stripeMapSafe = stripeMap ?? {};
  const stripeType: any = Object.entries(stripeMapSafe).map(([value, label]) => ({
    value,
    label,
  }));

  const onSubmit = async (values: any) => {
    values = {
      ...values,
      priceId: values?.priceId,
      subscriptionId: values?.subscriptionId,
      quantity: values?.quantity,
    };
    // delete values.paymentMethodId;
    // delete values.price;
    // delete values.subscriptionId;
    // delete values.quantity;
    const body: MyObjectType = {};
    let key: string | number;
    let key2: string | number;
    for (key in values) {
      if (typeof data[key] === 'object' && !Array.isArray(data[key]) && data[key] != null) {
        for (key2 in values[key]) {
          if (
            typeof values[key][key2] === 'object' &&
            !Array.isArray(values[key][key2]) &&
            values[key][key2] != null
          ) {
            if (JSON.stringify(values[key][key2]) != JSON.stringify(data[key][key2])) {
              body[key] = values[key];
              break;
            }
          } else if (data[key][key2] != values[key][key2]) {
            body[key] = values[key];
            break;
          }
        }
      } else if (data[key] != values[key]) {
        body[key] = values[key];
      }
    }
    sendEvent(`Company page`, `Company  Changed `, `Company  page Submit`, 1);
    companies.companyPatchData(body, id);
    refetch();
  };

  const sendStripeLogs = async () => {
    const response = await companies.getStripeLogs(data?.uid);
    if (response) {
      downloadCSV(response);
      sendEvent('Download button Stripe Tab', `Download button Stripe Tab`, `Button Download`, 1);
    }
  };

  const productOptions =
    getProducts?.data?.products?.map((product: any) => ({
      label: product.name,
      value: product.id,
    })) || [];

  const priceOptions =
    getPrices?.data?.prices.map((price: any) => ({
      label: `${price.unit_amount / 100} ${price.currency?.toUpperCase() || ''}`.trim(),
      value: price.id,
    })) || [];

  return (
    <Card>
      <Spin size="large" spinning={!data}>
        {data && (
          <FormAnt
            name="basic"
            layout="vertical"
            initialValues={{
              ...data,
              priceId: data?.priceId,
              subscriptionId: data?.subscriptionId,
              quantity: data?.quantity,
            }}
            onFinish={onSubmit}
            autoComplete="off"
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Space direction="vertical" style={{ width: '50%' }}>
              <FormAnt.Item
                wrapperCol={{ span: '100%' }}
                label="Stripe Customer ID"
                name="stripeCustomerId"
              >
                <Input />
              </FormAnt.Item>
              <FormAnt.Item wrapperCol={{ span: '100%' }} label="Product">
                <Select
                  placeholder="Select product"
                  style={{ width: '100%' }}
                  allowClear
                  disabled={!canEditPrice}
                  loading={getProducts?.isLoading}
                  value={productId}
                  onChange={(value) => setProductId(value)}
                  options={productOptions}
                />
              </FormAnt.Item>
              <FormAnt.Item wrapperCol={{ span: '100%' }} label="Price" name="priceId">
                <Select
                  placeholder="Select price"
                  style={{ width: '100%' }}
                  disabled={!canEditPrice}
                  loading={getPrices?.isLoading}
                  options={priceOptions}
                />
              </FormAnt.Item>
              <FormAnt.Item
                wrapperCol={{ span: '100%' }}
                label="Subscription ID"
                name="subscriptionId"
              >
                <Input placeholder="subscription id" />
              </FormAnt.Item>
              <FormAnt.Item
                wrapperCol={{ span: '100%' }}
                label="Quantity"
                name="quantity"
                rules={[
                  { type: 'number', warningOnly: true },
                  { type: 'number', min: 0, max: 0, message: 'Please enter a number 0' },
                ]}
              >
                <InputNumber placeholder="quantity" style={{ width: '100%' }} />
              </FormAnt.Item>

              <FormAnt.Item wrapperCol={{ span: '100%' }} label="Stripe Type" name="stripeType">
                <Select style={{ width: '100%' }}>
                  {stripeType.map((data: any) => (
                    <Option key={data.value} value={data.value}>
                      {data.label}
                    </Option>
                  ))}
                </Select>
              </FormAnt.Item>

              <FormAnt.Item>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </FormAnt.Item>
            </Space>

            <Space direction="vertical" style={{ width: '300px' }}>
              <Text>
                Download a company's activity record for over the past 6 months. This file can be
                shared with Stripe as proof of platform usage.
              </Text>
              <Button type="primary" onClick={sendStripeLogs}>
                Download Stripe Logs
              </Button>
            </Space>
          </FormAnt>
        )}
      </Spin>
    </Card>
  );
};

export default Stripe;
